// imports section
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Checkbox,
  Typography,
  Collapse,
  IconButton,
  CircularProgress,
  capitalize,
  TextField,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  Table,
  Paper,
  TableContainer,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Navbar from "../../components/common/Navbar";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import {
  CON_STATUS_ACTIVE,
  CON_STATUS_DELETED,
} from "../../utils/sys/Constants";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import {
  SHOP_API_01,
  SHOP_API_04,
  SHOP_API_05,
  USERGROUP_API_01,
  USERGROUP_API_06,
  USERS_API_08,
  USERS_COMPANY_USERS_API,
} from "../../api/ApiModel";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import {
  MSG_GROUPACCESS_SUCCESS,
  MSG_GROUPACCESS_FAILED,
  MSG_INPUTS_FAILED,
} from "../../utils/sys/Messages";

const MapUsers = () => {
  // Hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [selectedModule, setSelectedModule] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [currentDate, setCurrentDate] = useState("");

  const [userGroups, setUserGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [shops, setShops] = useState([]);
  const [storeUsers, setStoreUsers] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedShop, setSelectedShop] = useState(""); // Hooks

  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, USERNAME, RESTCODE, SYSDATE } =
    SYS_USER.USER_PARAM || {};

  useEffect(() => {
    fetchUserGroups();
    fetchShops();
    fetchUsers();
    fetchStoreUsers();
  }, []);

  // Handlers

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleDateChange = (event) => {
    setCurrentDate(event.target.value);
  };
  useEffect(() => {
    // Fetching today's date and formatting it
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // Format as 'YYYY-MM-DD'
    setCurrentDate(formattedDate);
  }, []);

  useEffect(() => {
    if (selectedShop) {
      fetchStoreUsers(selectedShop.RESTCODE);
    } else {
      setStoreUsers([]); // Clear the storeUsers state
    }
  }, [selectedShop]);

  const handleShopChange = (event) => {
    const shopRestCode = event.target.value;
    const selectedShop = shops.find((shop) => shop.RESTCODE === shopRestCode);
    setSelectedShop(selectedShop);

    // Fetch and set store users without clearing
    if (selectedShop) {
      fetchStoreUsers(selectedShop.RESTCODE);
    }
  };

  const handleUserChange = (event) => {
    const selectedValue = event.target.value; // The value from the Select field
    const selectedUser = users.find(
      (user) => user.USERREFCODE === selectedValue
    ); // Find the selected user object
    setSelectedUser(selectedUser); // Set the selected user object
  };
  const handleGroupChange = (event) => {
    const selectedValue = event.target.value;
    const selectedGroup = userGroups.find(
      (group) => group.GROUPCODE === selectedValue
    );
    setSelectedGroup(selectedGroup);
  };
  // API calls

  // Fetch user groups from API
  const fetchUserGroups = async () => {
    setLoading(true);
    try {
      const params = {
        COMPCODE: COMPCODE,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(USERGROUP_API_01, "GET", params);
      setUserGroups(response); // Assuming response is an array of user groups

      console.log("fetchUserGroups", response);
    } catch (error) {
      setError("Failed to fetch user groups.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch users
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const params = {
        COMPCODE: COMPCODE,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(
        USERS_COMPANY_USERS_API,
        "GET",
        params
      );
      setUsers(response); // Assuming response is an array of user groups

      console.log("fetchUsers", response);
    } catch (error) {
      setError("Failed to fetch user groups.");
    } finally {
      setLoading(false);
    }
  };

  const fetchShops = async () => {
    try {
      const response = await externalgetApi(SHOP_API_01, "get", {
        COMPCODE: COMPCODE,
        GROUPCODE: GROUPCODE,
        USERNAME: USERNAME,
        // CATTYPE: "R",
        STS: CON_STATUS_ACTIVE,
      });
      setShops(response);

      console.log("result shop", response);
      setIsLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchStoreUsers = async (restCode) => {
    if (!restCode) return;
    setIsLoading(true);
    try {
      const response = await externalgetApi(SHOP_API_04, "get", {
        COMPCODE: String(selectedShop?.COMPCODE || ""),
        LOCCODE: String(selectedShop?.LOCCODE || ""),
        RESTCODE: String(restCode),
        STS: CON_STATUS_ACTIVE,
      });
      setStoreUsers(response);

      console.log("fetch Store Users ", response);
      setIsLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const validateInputs = () => {
    if(selectedShop && selectedUser && selectedGroup && currentDate){
      return true
    } else {
      return false
    }
  }

  const handleSubmit = async () => {
    try {
      if(validateInputs()){
      const payload = {
        compcode: String(selectedShop?.COMPCODE || ""),
        loccode: String(selectedShop?.LOCCODE || ""),
        restcode: String(selectedShop?.RESTCODE || ""),
        username: selectedUser?.USERNAME || "",
        usergroup: selectedGroup?.GROUPCODE || "",
        startdate: currentDate || "",
        locdate: SYSDATE,
        enuser: USERNAME,
        actsts: CON_STATUS_ACTIVE,
        delsts: "N",
      };
      const response = await externalpostApi(SHOP_API_05, payload);
      console.log("post response", response);
      setSnackbarMessage(MSG_GROUPACCESS_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      handleClearFields();
      if (selectedShop?.RESTCODE) {
        fetchStoreUsers(selectedShop.RESTCODE);
      }
    } else {
      setSnackbarMessage(MSG_INPUTS_FAILED);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } 
    } catch (error) {
      setError("Failed to update access mapping.");
      console.error("API call error:", error);
    }
  };
  const handleDeleteUser = async (user) => {
    try {
      const payload = {
        compcode: String(selectedShop?.COMPCODE || ""),
        loccode: String(selectedShop?.LOCCODE || ""),
        restcode: String(selectedShop?.RESTCODE || ""),
        username: user.USERNAME,
        usergroup: user.USERGROUP, // Assuming usergroup is part of user object
        startdate: currentDate || "",
        locdate: SYSDATE,
        enuser: USERNAME,
        actsts: "D", // Indicating deletion
        delsts: "D", // Marking as deleted
      };

      const response = await externalpostApi(SHOP_API_05, payload);
      console.log("Delete response:", response);

      // Show success message
      setSnackbarMessage("User removed successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      // Refresh the list after deletion
      fetchStoreUsers(selectedShop?.RESTCODE);
    } catch (error) {
      console.error("Error deleting user:", error);
      setSnackbarMessage("Failed to remove user.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSelectShop = (shop) => {
    setSelectedShop(shop);
    console.log("Selected Shop:", shop);
    // Navigate to mapping users or perform other actions
  };

  const handleClearFields = () => {
    setSelectedModule("");
    setSelectedGroup(null);
    setSelectedUser("");
    // setSelectedShop("");
    setCurrentDate(""); // Reset the date if required
    // setStoreUsers([]);
  };

  return (
    <>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Employee</Link>
                <Link underline="none">Map Users</Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.box_container_add}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={styles.col_title}>
              <Typography variant="title" align="left">
                Map Users
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            // height={"40vh"}
            overflow={"hidden"}
          >
            <Box
              px={3}
              // height={"20vh"}
              sx={{
                ...styles.col_1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                textAlign: "left",
                padding: 2,
                marginLeft: 0,
                // height: "42vh",

                height: {
                  xs: "60vh",
                  sm: "60vh",
                  md: "42vh",
                  lg: "42vh",
                  xl: "42vh",
                },
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.text.primary,
                  marginBottom: 2,
                }}
                gutterBottom
              >
                Mapped Users
              </Typography>

              {isLoading ? (
                <CircularProgress />
              ) : (
                <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={styles.table_header}>
                          Shop Name
                        </TableCell>
                        <TableCell sx={styles.table_header}>
                          Description
                        </TableCell>
                        <TableCell sx={styles.table_header} align="center">
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {shops.map((shop) => (
                        <TableRow key={shop.RESTCODE}>
                          <TableCell>{shop.RESTNAME}</TableCell>
                          <TableCell>{shop.DESCRIPTION || "N/A"}</TableCell>
                          <TableCell align="center">
                            <Button
                              variant="contained"
                              color="primary"
                              sx={styles.btn_primary}
                              onClick={() => handleSelectShop(shop)}
                            >
                              Select
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Box
              sx={{
                ...styles.col_1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                textAlign: "left",
                padding: 2,
                marginLeft: 0,

                height: {
                  xs: "auto",
                  sm: "auto",
                  md: "42vh",
                  lg: "42vh",
                  xl: "42vh",
                },
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.text.primary,
                  marginBottom: 1,
                  textAlign: "left",
                }}
                gutterBottom
              >
                Map Users
              </Typography>
              <FormControl fullWidth size="small">
                {selectedShop ? (
                  <Typography variant="subtitle1">
                    Shop : {selectedShop.RESTNAME}
                  </Typography>
                ) : (
                  <Typography variant="subtitle1" color="textSecondary">
                    Shop : No Shop Selected
                  </Typography>
                )}
              </FormControl>

              <Box mt={2} width={"100%"}>
                <FormControl fullWidth size="small">
                  <InputLabel id="group-select-label">User Name</InputLabel>
                  <Select
                    labelId="group-select-label"
                    id="group-select"
                    label="User Group"
                    value={selectedUser ? selectedUser.USERREFCODE : ""}
                    onChange={handleUserChange}
                  >
                    {users.map((user) => (
                      <MenuItem key={user.USERREFCODE} value={user.USERREFCODE}>
                        {user.USERNAME}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box mt={2} width={"100%"}>
                <FormControl fullWidth size="small">
                  <InputLabel id="group-select-label">User Group</InputLabel>
                  <Select
                    labelId="group-select-label"
                    id="group-select"
                    label="User Group"
                    value={selectedGroup ? selectedGroup.GROUPCODE : ""}
                    onChange={handleGroupChange}
                  >
                    {userGroups.map((group) => (
                      <MenuItem key={group.GROUPCODE} value={group.GROUPCODE}>
                        {group.GROUPNAME}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box mt={2} width={"100%"}>
                <TextField
                  label="Start Date"
                  id="startDate"
                  size="small"
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                  type="date"
                  name="startDate"
                  value={currentDate}
                  onChange={handleDateChange}
                  InputLabelProps={{
                    shrink: true, // ensures that label shrinks when value is present
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  marginTop: 2,
                  width: "100%",
                  gap: 2,
                }}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleClearFields}
                  sx={{ ...styles.btn_secondary, width: "20%" }}
                >
                  Clear
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  // disabled={!selectedGroup || !selectedModule || loading}
                  sx={{ ...styles.btn_primary, width: "20%" }}
                >
                  Confirm
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                backgroundColor: theme.palette.background.paper,
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                borderRadius: "8px",
                padding: 3,
                // height: "25vh",

                height: {
                  xs: "40vh",
                  sm: "40vh",
                  md: "25vh",
                  lg: "25vh",
                  xl: "25vh",
                },
                width: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.text.primary,
                  // marginBottom: 2,
                }}
              >
                User Details
              </Typography>
              {storeUsers.length === 0 ? (
                <Box
                  sx={{
                    textAlign: "center",
                    marginTop: "auto",
                    marginBottom: "auto",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      color: theme.palette.text.secondary,
                    }}
                  >
                    No users mapped to this shop.
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    flexGrow: 1,
                    overflowY: "auto",
                    px: 2,
                    marginTop: 1,
                  }}
                >
                  {storeUsers.map((user) => (
                    <Box
                      key={user.RESTCODE}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "12px",
                        borderRadius: "6px",
                        backgroundColor: theme.palette.background.default,
                        marginBottom: 2,
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
                        "&:hover": {
                          backgroundColor: theme.palette.action.hover,
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 500,
                          color: theme.palette.text.primary,
                        }}
                      >
                        {user.USERNAME} ({user.GROUPNAME})
                      </Typography>
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{
                          textTransform: "none",
                        }}
                        onClick={() => handleDeleteUser(user)}
                      >
                        Remove
                      </Button>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
};

export default MapUsers;
